export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 max-w-4xl mx-auto">
          {/* Left mockup */}
          <div className="shrink-0 relative w-[200px] h-[380px] md:w-[240px] md:h-[440px] rounded-[2rem] bg-background-200 border-4 border-background-300 overflow-hidden">
            <div className="absolute top-0 inset-x-0 h-8 bg-background-300 rounded-b-xl flex items-center justify-center">
              <div className="w-16 h-1.5 rounded-full bg-background-400" />
            </div>
            <div className="pt-10 px-4 space-y-3">
              <div className="flex items-center justify-center">
                <span className="text-sm font-bold text-primary-500 font-heading">番茄影视</span>
              </div>
              <div className="h-2 w-3/4 mx-auto rounded-full bg-background-300" />
              <div className="h-2 w-1/2 mx-auto rounded-full bg-background-300" />
              {[...Array(4)].map((_, i) => (
                <div key={i} className="h-28 rounded-lg bg-background-300" />
              ))}
            </div>
          </div>

          {/* Right content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">移动客户端</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              番茄影视移动版已全面适配手机与平板浏览器，无需下载安装，打开浏览器即可畅享高清影视。页面采用移动优先设计，触控交互流畅，支持横竖屏自由切换，通勤路上、午休间隙、周末躺平，随时随地追剧看片。后续将推出独立APP客户端，敬请期待。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-smartphone-line text-primary-500 text-lg" />
                <span>手机浏览器直接访问</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-tablet-line text-primary-500 text-lg" />
                <span>平板大屏沉浸体验</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-download-2-line text-primary-500 text-lg" />
                <span>独立APP即将上线</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}